import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { Command, CommandContribution, CommandRegistry } from '@patsnap/tahiti-core/common/command';
import { I18nService } from '@telecom/shared/services/i18n';
import IconAddMore from '@/presentation/assets/images/icons/icon-longer.svg';
import { i18nDeferred } from '@/infrastructure/locales/deferred';
import { SpecificationParagraphAiEditType } from '@/domains/specification/enums';
import { EmbodimentGenerator } from '@/presentation/pages/specification/components/embodiment-generator';
import type { Component, DefineComponent } from 'vue';

interface CustomCommandRegistration extends Command {
    component?: Component | DefineComponent;
}
@injectable()
export class AddEmbodimentCommandContribution implements CommandContribution {
    constructor(
        @inject(I18nService)
        private _i18nService: I18nService,
    ) {
    }


    async registerCommands(commands: CommandRegistry): Promise<void> {
        await i18nDeferred.promise;

        commands.registerCommand({
            id: SpecificationParagraphAiEditType.AddEmbodiment,
            label: this._i18nService.t('aiDisclosure.addEmbodiment'),
            icon: IconAddMore,
            component: EmbodimentGenerator,
        } as CustomCommandRegistration, {
            execute: () => {
                return {
                    // 从 自己 service 中获取
                };
            },
        });

    }
}
